import _ from "lodash";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Count, RightArrow, Title, TitleSection } from "./styled";

interface IProps {
  userId: Moim.Id;
  types: {
    type: any;
    subTypes?: any[];
  }[];
  title?: string;
  pageTitle?: string;
}

const UserContentGroupPreview: React.FC<IProps> = ({ title }) => {
  const handleRedirectUserContents = () => {};
  return (
    <TitleSection role="button" onClick={handleRedirectUserContents}>
      <Title>
        {title ?? <FormattedMessage id="profile_show_created_content_title" />}
      </Title>
      <Count>{0}</Count>
      <RightArrow />
    </TitleSection>
  );
};

export default UserContentGroupPreview;
